import React from "react";

function Flag() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 511.999 511.999"
    >
      <path
        fill="#e21b1b"
        d="M103.919 51.744s41.296 33.496 109.008 18.4C277.127 55.88 336.983 39.68 437.543 76v215.032s-92.488-44.104-176.736-24.432-131.88 12.12-156.888-12.888"
        data-original="#e21b1b"
      ></path>
      <path
        fill="#999"
        d="M90.74 37.524h16v474.475h-16z"
        data-original="#999999"
      ></path>
      <circle
        cx="98.741"
        cy="24.284"
        r="24.284"
        fill="#666"
        data-original="#666666"
      ></circle>
    </svg>
  );
}

export default Flag;
